import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
// Import tracking FIRST so its top-level UTM snapshot runs before the router
// mounts and before any redirect can rewrite the URL.
import "./lib/tracking";
import App from "./App.tsx";
import AppErrorBoundary from "./components/AppErrorBoundary";
import "./index.css";

// Self-hosted fonts (replaces Google Fonts CSS in index.html).
import "@fontsource-variable/inter/index.css";
import "@fontsource/jetbrains-mono/400.css";
import "@fontsource/jetbrains-mono/500.css";

createRoot(document.getElementById("root")!).render(
  <AppErrorBoundary>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </AppErrorBoundary>,
);
